<template>
  <div>
    <a
      v-if="link"
      class="btn btn-block btn-primary rounded-0 py-2"
      :href="link"
    >
      <span class="d-block py-1">
        {{ label }}
      </span>
    </a>

    <button
      v-else
      class="btn btn-block btn-primary rounded-0 py-2"
      :disabled="disabled"
      @click="addToCart"
      @keypress="addToCart"
    >
      <span class="d-block py-1">
        {{ label }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    deal: {
      type: Object,
      required: true,
    },
    additionalText: {
      type: String,
      default: '',
    },
    hasPlus: {
      type: Boolean,
      default: () => (false),
    },
    selectedPlan: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      label: '',
      link: '',
      disabled: false,
    };
  },
  watch: {
    additionalText() {
      this.createLabelData();
    },
  },
  created() {
    this.createLabelData();
  },
  methods: {
    onClickButton() {
      if (!this.disabled) {
        this.$emit('click-buy');
      }
    },

    createLabelData() {
      let label = `Buy now ${this.additionalText || ''}`;
      let link = '';
      let disabled = this.deal.buy_button.is_draft;

      if (this.deal.buy_button.is_last_call || this.deal.buy_button.is_early_access) {
        if (this.hasPlus) {
          label = 'Buy Now With Plus';
        } else {
          label = 'Join Plus now to buy';
          link = '/plus/';
        }
      } else if (this.deal.buy_button.is_coming_soon || this.deal.buy_button.is_ended) {
        label = 'Coming soon';
        disabled = true;
      } else if (this.deal.is_free || this.deal.buy_button.is_get_now) {
        label = this.deal.is_free ? 'Get now for FREE' : 'Get now';

        if (this.deal.clickthrough_url) {
          link = this.deal.clickthrough_url;
        }
      }

      this.label = label;
      this.link = link;
      this.disabled = disabled;
    },

    addToCart() {
      this.isDisabled = true;
      const data = new FormData();

      data.append('id', this.deal.id);

      if (this.selectedPlan) {
        data.append('plan_id', this.selectedPlan.id);
        data.append('quantity', this.selectedPlan.codes);
      } else if (this.deal.default_plan) {
        data.append('plan_id', this.deal.default_plan.id);
      }

      if (this.deal.is_free) {
        const quantity = (this.deal.use_licensing) ? 1 : this.deal.default_plan.codes;
        data.append('quantity', quantity);
      }

      const options = {
        headers: {
          'X-CSRFToken': this.$cookies.get('csrftoken'),
          'Content-Type': 'multipart/form-data',
        },
      };

      this.$axios.post('/cart/add/', data, options)
        .then(() => {
          if (window) {
            window.location = '/cart/';
          }
        })
        .catch(() => {
          this.$toastr.e('Something has gone wrong with this request. Please try again.');
          this.isDisabled = false;
        });
    },
  },
};
</script>

<style scoped>
  .btn-primary {
    border: 1px solid #ffbc00;
    background-color: #ffbc00;
    color: #272727;
    border-radius: 4px !important;
  }

  .btn-primary:hover,
  .btn-primary:disabled {
    border-color: #ffcb33;
    background-color: #ffcb33;
    color: #272727;
  }

  .btn-primary:active {
    border-color: #ffcb33 !important;
    background-color: #ffcb33 !important;
    color: #272727 !important;
  }
</style>
